module.exports = __webpack_public_path__ + "static/rectangle-bg-856893b56dd1e8504bdb9f6a2b9ff0ee.png";